import React from "react"
import {
    LiveKitRoomProps,
    LKFeatureContext,
    RoomContext,
    useLiveKitRoom,
} from "@livekit/components-react"

export const LiveKitRoom: (
    props: React.PropsWithChildren<LiveKitRoomProps> &
        React.RefAttributes<HTMLDivElement>
) => React.ReactNode = /* @__PURE__ */ React.forwardRef<
    HTMLDivElement,
    React.PropsWithChildren<LiveKitRoomProps>
>(function LiveKitRoom(props: React.PropsWithChildren<LiveKitRoomProps>, ref) {
    const { room, htmlProps } = useLiveKitRoom(props)

    return (
        room && (
            <RoomContext.Provider value={room}>
                <LKFeatureContext.Provider value={props.featureFlags}>
                    {props.children}
                </LKFeatureContext.Provider>
            </RoomContext.Provider>
        )
    )
})
